import { defineStore } from 'pinia';
import { mande } from 'mande';

import { auth0 } from '../auth0.js';

export const initApi = async () => {
  const token = await auth0.getAccessTokenSilently();

  return mande(`${import.meta.env.VITE_APP_API_URL}/companies`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

export const initUserApi = async () => {
  const token = await auth0.getAccessTokenSilently();

  return mande(`${import.meta.env.VITE_APP_API_URL}/users`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

interface ETNCompany {
  name: string;
}

export interface ETNCompanyListItem {
  _id: string;
  name: string;
  featureFlags?: Record<string, unknown>;
}

interface CompanyState {
  company: ETNCompany;
  globalCompanies: ETNCompanyListItem[];
}

export const useStore = defineStore('company', {
  state: (): CompanyState => {
    return {
      company: {
        name: 'N/A'
      },
      globalCompanies: []
    };
  },
  actions: {
    async getCompany(id: string) {
      try {
        const api = await initApi();
        this.company = await api.get(id);
      } catch (e) {
        return e;
      }
    },
    async getGlobalCompanies(): Promise<ETNCompanyListItem[]> {
      const api = await initApi();
      const result = (await api.get('global')) as ETNCompanyListItem[];
      this.globalCompanies = result;
      return result;
    },
    async setCompanyId(payload: { userSub: string; companyId: string }): Promise<void> {
      const api = await initUserApi();
      await api.put(`${payload.userSub}/company-id`, { companyId: payload.companyId });
    }
  }
});
